import React from 'react';
import { TableTransfer, TimeWithTimeZone } from '@common/components';
import { filterableColumnBuilder } from 'works/legacy/lib/table-filters-helper';
import { Membership } from 'works/legacy/graphql/works-memberships';

export type MembershipWithDisable = Membership & { disabled?: boolean };

type Props = {
  selectedWorksMembershipIds: string[];
  onWorksMembershipIdsChange: (worksMembershipIds: string[]) => void;
  loading: boolean;
  worksMemberships: MembershipWithDisable[];
};

const column = filterableColumnBuilder<Membership>({});

const tableColumns = [
  column({
    key: 'firstName',
    title: 'First Name',
  }),
  column({
    key: 'lastName',
    title: 'Last Name',
  }),
  column({
    key: 'roleName',
    title: 'Role',
  }),
  column({
    key: 'updatedAt',
    title: 'Last Updated',
    render: (date) => <TimeWithTimeZone date={date} variant="long_format" />,
  }),
];

export function MembersUpdateLocationsStepSelectMembers({
  selectedWorksMembershipIds,
  onWorksMembershipIdsChange,
  loading,
  worksMemberships,
}: Props) {
  return (
    <TableTransfer
      loading={loading}
      className="members-selection-update-locations-step"
      dataSource={worksMemberships}
      targetKeys={selectedWorksMembershipIds}
      disabled={false}
      onChange={onWorksMembershipIdsChange}
      columns={tableColumns}
      showSearch
    />
  );
}
